// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__249Nm","footer":"ModalFilter_footer__Mefgf"};